<template>
  <div>
    <p
      v-if="error"
      class="text-danger"
      >{{ errorMsg }}</p
    >

    <div
      v-if="initialLoading"
      key="initialLoading"
      class="animate__animated animate__fadeIn animate_fadeOut animate__fast"
    >
      <busy-spinner
        inner-class="my-5"
        :text="$t('companyList.loadingVendors')"
      ></busy-spinner>
    </div>

    <div
      v-if="!initialLoading"
      key="initialLoadingDone"
    >
      <div class="d-flex flex-wrap justify-content-between align-items-end mb-3 animate__animated animate__fast animate__fadeInUp">
        <base-search-box
          :value="currentFilterValues.searchFilter"
          ref="searchBox"
          :placeholder="$t('companyList.quickSearchPlaceholder')"
          @search="setFilterAndSearch('searchFilter', $event)"
          @reset="setFilterAndSearch('searchFilter', '')"
        ></base-search-box>
        <b-form
          inline
          class="mt-2"
        >
          <div class="align-self-end">
            <b-button
              variant="soft-primary"
              :disabled="!showFilterReset"
              class="text-uppercase"
              @click="clearAllFilters"
            >
              {{ $t('companyList.clearFilters') }}
            </b-button>
          </div>
          <!-- <base-filter-select
                        label="NDA on file?"
                        v-model="currentFilterValues.ndaFilter"
                        :reset-value="initialFilterValues.ndaFilter"
                        :options="ndaOptions"
                        @change="getNewList"
                    ></base-filter-select> -->
          <b-button
            v-b-tooltip.hover
            :title="$t('companyList.refreshList')"
            variant="light"
            class="ml-2 align-self-end"
            @click="refreshList(true)"
          >
            <b-icon icon="arrow-repeat"></b-icon>
          </b-button>
        </b-form>
        <!-- <div v-if="!loading && totalRows" class="font-size-90 text-muted">{{totalRows}} Vendors</div> -->
        <!-- <b-button variant="success" @click="handleAdd">
                    <b-icon icon="plus-circle" class="mr-1"></b-icon>
                    Add Vendor
                </b-button> -->
      </div>

      <b-card
        id="vendor-contact-table-card"
        class="shadow rounded-lg animate__animated animate__fadeIn animate__fast"
        no-body
      >
        <div
          v-if="!loading && !totalRows"
          class="d-flex justify-content-center align-items-center"
          style="min-height: 300px"
        >
          <div class="text-center">
            <div class="font-size-100 text-muted mb-4">
              {{ hasAppliedFilters ? $t('companyList.noVendorsFound') : $t('companyList.noVendorsYet') }}
            </div>
            <b-button
              v-if="hasAppliedFilters"
              variant="soft-primary"
              @click="clearAllFilters"
            >
              {{ $t('companyList.clearSearch') }}
            </b-button>
            <b-button
              v-if="!hasAppliedFilters"
              size="lg"
              variant="soft-success"
              @click="handleAdd"
            >
              {{ $t('companyList.addVendor') }}
            </b-button>
          </div>
        </div>

        <b-table
          v-else
          id="company-list-table"
          :items="itemList"
          :fields="fields"
          :busy="loading"
          primary-key="id"
          no-local-sorting
          no-sort-reset
          :sort-by.sync="sortByField"
          :sort-desc.sync="sortDesc"
          @sort-changed="getNewList"
          hover
          class="no-top-border td-align-middle mb-0"
          thead-class="overflow-hidden cells-align-middle"
          head-variant="light"
        >
          <!-- <template #table-busy>
                        <busy-spinner inner-class="my-5"></busy-spinner>
                    </template> -->
          <template v-slot:cell(name)="data">
            <b-link :href="data.item.get_absolute_url">{{ data.value }}</b-link>
          </template>

          <template
            #cell(company_tags)="data"
          >
            <featured-vendor-tag-group :tags="data.value"></featured-vendor-tag-group>
          </template>

          <template
            #cell(taggings_by_field)="data"
            v-if="dynamicTaggingEnabled"
          >
            <TagFieldLocationDisplay
              v-model="data.value"
              location-slug="vendors.company.list"
            ></TagFieldLocationDisplay>
          </template>

          <template #cell(primary_location_string)="data">
            <span class="mr-2">{{ data.value }}</span>
            <country-flag
              v-if="data.item.primary_location_country_code"
              :country="data.item.primary_location_country_code"
              size="sm"
              border
              rounded
            ></country-flag>
          </template>
          <template #cell(active_contact_count)="data">
            {{ data.value === 0 ? '-' : data.value }}
          </template>
          <template #cell(created)="data">
            {{ data.value | dateFilter }}
          </template>
          <template #cell(actions)="data">
            <b-button-group
              class=""
              style=""
            >
              <b-button
                @click="onResourceShowModal(data.item)"
                size="sm"
                variant="gray-secondary"
              >
                <b-icon
                  icon="lightning"
                  variant="warning"
                  class=""
                ></b-icon>
                {{ $t('companyList.quickView') }}
              </b-button>
              <b-button
                :href="data.item.get_absolute_url"
                size="sm"
                variant="gray-secondary"
              >
                <b-icon
                  icon="card-list"
                  variant="primary"
                  class="mr-1"
                ></b-icon>
                {{ $t('companyList.details') }}
              </b-button>
              <b-dropdown
                v-if="getMoreActions().length"
                size="sm"
                variant="gray-secondary"
              >
                <template #button-content>{{ $t('companyList.more') }}</template>
                <!-- getMoreActions should include logic for checking role of currentUserInfo to limit what is available -->
                <b-dropdown-item
                  v-for="action in getMoreActions()"
                  :key="action.label"
                  @click="action.onClick(data.item)"
                >
                  <b-icon 
                    v-if="action.icon && action.icon.icon" 
                    :icon="action.icon.icon" 
                    :variant="action.icon.variant || 'primary'" 
                    class="mr-1"></b-icon>
                  {{ action.label }}
                </b-dropdown-item>
              </b-dropdown>
            </b-button-group>
            <!-- DROPDOWN STILL WORKS, BUT WE HAVE LOTS OF ROOM, SO USING BUTTONS INSTEAD -->
            <!-- <b-dropdown variant="gray-secondary" no-caret size="sm" toggle-class="border shadow-sm">
                            <template #button-content>
                                <b-icon icon="three-dots"></b-icon>
                            </template>
                            <b-dropdown-item @click="onResourceShowModal(data.item)">
                              <b-icon icon="lightning" variant="warning" class="mr-2"></b-icon>
                                Quick View
                            </b-dropdown-item>
                            <b-dropdown-item :href="data.item.get_absolute_url">
                                <b-icon icon="card-list" variant="primary" class="mr-2"></b-icon>
                                Details
                            </b-dropdown-item>
                        </b-dropdown> -->
          </template>
        </b-table>
        <template
          #footer
          v-if="!loading && totalRows"
        >
          <base-table-pagination
            :current-page.sync="currentPage"
            :per-page.sync="perPage"
            :total-items="totalRows"
            show-per-page
            :item-name="$t('companyList.paginationItemName')"
            @update:perPage="getNewList"
            @update:currentPage="getList"
          ></base-table-pagination>
        </template>
      </b-card>
    </div>
    <!-- End of area to toggle when loading -->

    <ResourceModal
      ref="resourceModal"
      @saved="getList"
    />

    <b-modal
      v-if="rfxInviteCompany"
      v-model="rfxInviteModalShowing"
      :title="rfxInviteCompany ? $t('companyList.inviteModalTitle', { name: rfxInviteCompany.name }) : ''"
      size="xl"
      hide-footer
      centered
      no-close-on-backdrop
      @hidden="resetRfxInvite"
    >
      <CompanyBulkInviteRfx
        :company-id="rfxInviteCompany.id"
        @done="rfxInviteModalShowing = false"
        @cancel="rfxInviteModalShowing = false"
      />
    </b-modal>
  </div>
</template>

<script>
  import { suppliosApi } from '@/js/api-service';
  import BaseTablePagination from '@/components/BaseTablePagination';
  import { FormatDateHelper } from '@/js/filters-helpers';
  import BaseSearchBox from '@/components/BaseSearchBox';
  import ResourceModal from '@/components/resources/ResourceModal';
  import isEqual from 'lodash/isEqual';
  import { splTableDefaults, currentUserInfoMixin, tenantInfoMixin } from '@/js/custom-vue-mixins';
  import CompanyBulkInviteRfx from '@/components/rfx_internal/CompanyBulkInviteRfx.vue';

  import TagFieldLocationDisplay from '@/components/taxonomy/taggings/TagFieldLocationDisplay.vue';

  import FeaturedVendorTagGroup from '../components/FeaturedVendorTagGroup.vue';

  export default {
    name: 'CompanyList',
    components: {
      BaseTablePagination,
      BaseSearchBox,
      //BaseFilterSelect,
      ResourceModal,
      CompanyBulkInviteRfx,
      TagFieldLocationDisplay,
      FeaturedVendorTagGroup,
    },
    mixins: [currentUserInfoMixin, tenantInfoMixin],
    i18n: {
      messages: {
        en: {
          companyList: {
            loadingVendors: 'Loading Vendors...',
            quickSearchPlaceholder: 'Quick Search...',
            clearFilters: 'Clear Filters',
            refreshList: 'Refresh List',
            noVendorsFound: 'No vendors found.  Try a different search',
            noVendorsYet: 'No vendors yet.  Add one?',
            clearSearch: 'Clear Search',
            addVendor: 'Add Vendor',
            fields: {
              name: 'Name',
              tags: 'Tags',
              location: 'Location',
              numberOfContacts: 'Number of Contacts',
              dateAdded: 'Date Added',
              actions: 'Actions',
            },
            quickView: 'Quick View',
            details: 'Details',
            more: 'More',
            paginationItemName: 'companies',
            inviteToSourcingEvents: 'Invite to Sourcing Events',
            inviteModalTitle: 'Invite {name} to Sourcing Events',
            deactivate: 'Deactivate',
            deactivateConfirmTitle: 'Deactivate {name}',
            deactivateConfirmMessage: 'Are you sure you want to deactivate {name}? This will also deactivate all related contacts and other data associated with this company.',
            yesDeactivate: 'Yes, Deactivate',
            noCancel: 'No, Cancel',
            errorLoadingList: 'Error while loading itemList',
            errorDeactivating: 'Error while deactivating this company',
          },
        },
        es: {
          companyList: {
            loadingVendors: 'Cargando proveedores...',
            quickSearchPlaceholder: 'Búsqueda rápida...',
            clearFilters: 'Limpiar Filtros',
            refreshList: 'Actualizar Lista',
            noVendorsFound: 'No se encontraron proveedores. Intente con otra búsqueda',
            noVendorsYet: 'Aún no hay proveedores. ¿Desea agregar uno?',
            clearSearch: 'Limpiar Búsqueda',
            addVendor: 'Agregar Proveedor',
            fields: {
              name: 'Nombre',
              tags: 'Etiquetas',
              location: 'Ubicación',
              numberOfContacts: 'Número de Contactos',
              dateAdded: 'Fecha de Alta',
              actions: 'Acciones',
            },
            quickView: 'Vista Rápida',
            details: 'Detalles',
            more: 'Más',
            paginationItemName: 'empresas',
            inviteToSourcingEvents: 'Invitar a Eventos de Sourcing',
            inviteModalTitle: 'Invitar a {name} a Eventos de Sourcing',
            deactivate: 'Desactivar',
            deactivateConfirmTitle: 'Desactivar {name}',
            deactivateConfirmMessage: '¿Está seguro de que desea desactivar {name}? Esto también desactivará todos los contactos relacionados y otros datos asociados con esta empresa.',
            yesDeactivate: 'Sí, Desactivar',
            noCancel: 'No, Cancelar',
            errorLoadingList: 'Error al cargar la lista',
            errorDeactivating: 'Error al desactivar esta empresa',
          },
        },
        pt: {
          companyList: {
            loadingVendors: 'Carregando fornecedores...',
            quickSearchPlaceholder: 'Busca rápida...',
            clearFilters: 'Limpar Filtros',
            refreshList: 'Atualizar Lista',
            noVendorsFound: 'Nenhum fornecedor encontrado. Tente uma busca diferente',
            noVendorsYet: 'Ainda não há fornecedores. Deseja adicionar um?',
            clearSearch: 'Limpar Busca',
            addVendor: 'Adicionar Fornecedor',
            fields: {
              name: 'Nome',
              tags: 'Etiquetas',
              location: 'Localização',
              numberOfContacts: 'Número de Contatos',
              dateAdded: 'Data de Inclusão',
              actions: 'Ações',
            },
            quickView: 'Visualização Rápida',
            details: 'Detalhes',
            more: 'Mais',
            paginationItemName: 'empresas',
            inviteToSourcingEvents: 'Convidar para Eventos de Sourcing',
            inviteModalTitle: 'Convidar {name} para Eventos de Sourcing',
            deactivate: 'Desativar',
            deactivateConfirmTitle: 'Desativar {name}',
            deactivateConfirmMessage: 'Tem certeza de que deseja desativar {name}? Isso também desativará todos os contatos relacionados e outros dados associados a esta empresa.',
            yesDeactivate: 'Sim, Desativar',
            noCancel: 'Não, Cancelar',
            errorLoadingList: 'Erro ao carregar a lista',
            errorDeactivating: 'Erro ao desativar esta empresa',
          },
        },
        'zh-Hans': {
          companyList: {
            loadingVendors: '正在加载供应商...',
            quickSearchPlaceholder: '快速搜索...',
            clearFilters: '清除筛选',
            refreshList: '刷新列表',
            noVendorsFound: '未找到供应商。请尝试其他搜索',
            noVendorsYet: '还没有供应商。要添加一个吗？',
            clearSearch: '清除搜索',
            addVendor: '添加供应商',
            fields: {
              name: '名称',
              tags: '标签',
              location: '位置',
              numberOfContacts: '联系人数量',
              dateAdded: '添加日期',
              actions: '操作',
            },
            quickView: '快速查看',
            details: '详细信息',
            more: '更多',
            paginationItemName: '公司',
            inviteToSourcingEvents: '邀请参加寻源活动',
            inviteModalTitle: '邀请 {name} 参加寻源活动',
            deactivate: '停用',
            deactivateConfirmTitle: '停用 {name}',
            deactivateConfirmMessage: '确定要停用 {name} 吗？这也将停用与该公司关联的所有联系人和其他数据。',
            yesDeactivate: '是，停用',
            noCancel: '否，取消',
            errorLoadingList: '加载列表时出错',
            errorDeactivating: '停用该公司时出错',
          },
        },
        'zh-Hant': {
          companyList: {
            loadingVendors: '正在載入供應商...',
            quickSearchPlaceholder: '快速搜尋...',
            clearFilters: '清除篩選',
            refreshList: '重新整理清單',
            noVendorsFound: '找不到供應商。請嘗試其他搜尋',
            noVendorsYet: '還沒有供應商。要添加一個嗎？',
            clearSearch: '清除搜尋',
            addVendor: '添加供應商',
            fields: {
              name: '名稱',
              tags: '標籤',
              location: '位置',
              numberOfContacts: '聯絡人數量',
              dateAdded: '加入日期',
              actions: '操作',
            },
            quickView: '快速檢視',
            details: '詳細資料',
            more: '更多',
            paginationItemName: '公司',
            inviteToSourcingEvents: '邀請參加尋源活動',
            inviteModalTitle: '邀請 {name} 參加尋源活動',
            deactivate: '停用',
            deactivateConfirmTitle: '停用 {name}',
            deactivateConfirmMessage: '確定要停用 {name} 嗎？這也將停用與該公司關聯的所有聯絡人和其他資料。',
            yesDeactivate: '是，停用',
            noCancel: '否，取消',
            errorLoadingList: '載入清單時發生錯誤',
            errorDeactivating: '停用該公司時發生錯誤',
          },
        },
      },
    },
    props: {},
    data: function () {
      return {
        errorMsg: 'Error',
        error: false,
        initialLoading: true, // set to false after getting list the first time
        loading: false, // loading signal for fetching list
        currentPage: 1, // will get sync'd by base-table-pagination
        perPage: 25, // will get sync'd by base-table-pagination
        totalRows: null, // total items in list... need to set it after we get items from API, and also after filtering is applied with @filtered event
        itemList: [], // list from API

        // filtering
        currentFilterValues: {}, // v-models will update this, set it from initialFilterValues in created hook
        initialFilterValues: {
          searchFilter: '',
          //ndaFilter: null,  // should be true, false, null -- if null, it won't send query param, and will get all
        },
        ndaOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' },
          { value: null, text: 'Any' },
        ],
        hasAppliedFilters: false, // toggle this on when you are showing filtered results so you know the difference between no results at all, and no results from search
        // for sorting:
        sortByField: 'created', // sortByField and sortDesc will get .sync'd by b-table, then gets used in API call query params
        sortDesc: true, // sort descending = true (adds '-' sign in backend), sort ascending = false (no minus sign)
        tableTransitionProps: {
          name: 'staggered-fade',
          css: false,
        },
        rfxInviteCompany: null, // when you click on 'Invite to Sourcing Events' put the resource object here
        rfxInviteModalShowing: false, // v-model with rfx invite modal
      };
    },
    computed: {
      showFilterReset: function () {
        // returns BOOLEAN if any currentFilterValues are different than initialFilterValues
        let isSame = isEqual(this.currentFilterValues, this.initialFilterValues);
        return !isSame; // show filter reset if current filter values are NOT SAME as initial filter values
      },
      fields: function () {
        const fields = [
          {
            key: 'name',
            label: this.$t('companyList.fields.name'),
            sortable: true,
            api_ordering_name: 'name',
            tdClass: 'font-weight-bold max-width-300',
          },
          {
            key: 'company_tags',
            label: this.$t('companyList.fields.tags'),
            sortable: false,
            tdClass: 'max-width-200',
          },
          {
            key: 'primary_location_string',
            label: this.$t('companyList.fields.location'),
          },
          {
            key: 'active_contact_count',
            label: this.$t('companyList.fields.numberOfContacts'),
            class: 'text-center',
            sortable: true,
            api_ordering_name: 'active_contact_count',
          },
          {
            key: 'created',
            label: this.$t('companyList.fields.dateAdded'),
            class: 'text-center',
            sortable: true,
            api_ordering_name: 'created',
          },
          {
            key: 'actions',
            label: this.$t('companyList.fields.actions'),
            class: 'text-center',
          },
        ];

        // const sharedTagsField = {
        //   key: 'taggings_by_field',
        //   label: 'Tags',
        //   sortable: false,
        //   tdClass: 'max-width-200',
        // };
        // if (this.dynamicTaggingEnabled) {
        //   fields.splice(2, 0, sharedTagsField);
        // }
        return fields;
      },

      dynamicTaggingEnabled() {
        return this.$getTenantFlag('taxonomy_vendor_tags', false);
      },
    },
    filters: {
      dateFilter: function (value) {
        return FormatDateHelper(value);
      },
    },
    created: function () {
      this.resetFilterValues();
      this.perPage = splTableDefaults.perPage;
    },
    mounted: function () {
      this.getList();
    },
    methods: {
      // PUBLIC METHOD YOU CAN CALL FROM PARENT TO REFRESH LIST, likely just as $refs.something.refreshList();
      refreshList: function (noFilterReset = false) {
        if (noFilterReset) {
          this.getNewList(); // if you specifically set noFilterReset to true (first positional arg), then don't reset filters (but do reset current page to 1)
        } else {
          this.clearAllFilters(); // this resets all filter values and reloads the list
        }
      },
      handleError: function (error, message) {
        console.log(message);
        console.log(error);
        this.errorMsg = message;
        this.error = true;
      },
      onResourceShowModal(resource) {
        this.$refs.resourceModal.show(resource);
      },
      handleAdd: function () {
        // only used if list is empty and user clicks on 'add one' button
        // OLD this.$refs.vendorModal.show();
        // Aug 15 2022 - this has been not working since new VendorApp it seems...
        // for now I'll just emit event to parent, have that one show create modal
        // TODO - this needs to be fixed
        this.$emit('request-create');
      },
      resetFilterValues: function () {
        // old way
        this.currentFilterValues = Object.assign({}, this.initialFilterValues);
        // new way
        const filterRefs = ['searchBox'];
        filterRefs.forEach((refName) => {
          if (this.$refs[refName]) {
            this.$refs[refName].reset();
          }
        });
      },
      setFilterAndSearch(filterKey, value) {
        // pass in which filter to set and the value
        console.log('filterKey and value', filterKey, value);
        this.currentFilterValues[filterKey] = value;
        this.getNewList();
      },
      clearAllFilters: function () {
        // clear/reset all filters and search
        this.resetFilterValues();
        this.getNewList();
      },
      getOrderingFieldString: function () {
        // look up what field name (string) we should use to send to API, in case key here is different than what API should order by
        // useful if you have serializer methods that get values from related objects... you can use double-underscore notation in DRF for ordering
        // also add '-' if sortDesc is true
        let apiOrderingName = this.fields.find((fld) => fld.key === this.sortByField).api_ordering_name;
        return (this.sortDesc ? '-' : '') + apiOrderingName;
      },
      getNewList: function () {
        // call getList(), but must reset currentPage first
        // call this from any change to filters, sort, search, etc
        this.currentPage = 1;
        this.$nextTick(() => this.getList());
      },
      getList: function () {
        this.loading = true;
        // axiosConfig['params'] is where we put search/filter params
        let filterParams = {
          // grab the current search/filter values
          search: this.currentFilterValues.searchFilter || null,
          //nda_onfile: this.currentFilterValues.ndaFilter,
          // if you have more filters, put them here
        };
        let orderingParams = {
          ordering: this.getOrderingFieldString(),
        };
        let paginationParams = {
          page: this.currentPage,
          page_size: this.perPage,
        };
        let combinedParams = Object.assign({}, filterParams, orderingParams, paginationParams);
        let axiosConfig = { params: combinedParams };
        suppliosApi.vendorStandard
          .list(axiosConfig)
          .then((response) => {
            this.totalRows = response.data.count;
            this.itemList = response.data.results;
            this.$emit('list-loaded', this.totalRows); // emit total count to parent
            console.log('Got itemList from getList function');
            console.log(this.itemList);
            // need to set hasAppliedFilters after we get response, not before
            this.hasAppliedFilters = Object.values(filterParams).some((val) => !!val); // goes through all filter values, if any are not empty/null, returns true
          })
          .catch((error) => {
            this.handleError(error, this.$t('companyList.errorLoadingList'));
          })
          .finally(() => {
            console.log('hello from finally of getList');
            this.initialLoading = false; // set flag to say we already loaded once
            this.loading = false;
          });
      },
      /// MORE ACTIONS
      getMoreActions() {
        // could take arg of rowItem if needed
        // return ARRAY of objects for dropdown items in 'More' button/dropdown
        // MUST return array -- checking .length in the template
        // should include logic for checking role of currentUserInfo to limit what is available
        const moreActions = [];
        if (this.currentUserInfo.is_paid_seat) {
          moreActions.push({
            icon: {icon: 'envelope', variant: 'primary'},
            label: this.$t('companyList.inviteToSourcingEvents'),
            onClick: this.startRfxInvite, // call this with rowItem as arg in template
          });
        }
        if (this.$currentUserInfo.is_tenant_superadmin) {
          moreActions.push({
            icon: {icon: 'trash', variant: 'danger'},
            label: this.$t('companyList.deactivate'),
            onClick: this.startDeactivate, // call this with rowItem as arg in template
          });
        }
        return moreActions;
      },
      async startDeactivate(companyObj) {
        // start deactivation - show modal, if confirmed, then call performDeactivate
        const confirmed = await this.$bvModal.msgBoxConfirm(this.$t('companyList.deactivateConfirmMessage', { name: companyObj.name }), {
          title: this.$t('companyList.deactivateConfirmTitle', { name: companyObj.name }),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('companyList.yesDeactivate'),
          cancelTitle: this.$t('companyList.noCancel'),
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'light',
          centered: true,
        });
        if (confirmed) {
          try {
            await suppliosApi.vendorStandard.deactivate(companyObj.id);
            this.refreshList(true); // refresh list without resetting filters
          } catch (error) {
            this.handleError(error, this.$t('companyList.errorDeactivating'));
          }
        }
      },
      startRfxInvite(companyObj) {
        this.rfxInviteCompany = companyObj;
        this.rfxInviteModalShowing = true;
      },
      resetRfxInvite() {
        this.rfxInviteCompany = null;
        this.rfxInviteModalShowing = false; // likely already false...
      },
    },
  };
</script>

<style>
  /* table#company-list-table tr td {
  padding-top: 0;
  padding-bottom: 0;
} */
  /* TABLE-FADE - <transition name="table-fade"> */
  .table-fade-enter-active {
    transition: transform 0.7s;
  }
  .table-fade-enter /* .fade-leave-active below version 2.1.8 */ {
    transform: scaleY(0.1);
  }
</style>
